import axios from "axios";

// One backend serves every custom-domain host (bare + www); stay same-origin so the session cookie works
const ENV_URL = process.env.REACT_APP_BACKEND_URL;
export const BACKEND = ENV_URL && new URL(ENV_URL).host === window.location.host ? ENV_URL : window.location.origin;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

export const imgUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("/api/")) return `${BACKEND}${u}`;
  return /^https:\/\//i.test(u) ? u : "";
};

export const money = (n) =>
  `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const money0 = (n) => `$${Math.round(Number(n || 0)).toLocaleString("en-US")}`;

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return d || e?.message || "Something went wrong";
};

export const fmtDate = (s) =>
  s ? new Date(`${s.slice(0, 10)}T00:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "";

export function startLogin() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + window.location.pathname + window.location.search;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export async function uploadImage(file, kind = "listing") {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("kind", kind);
  const { data } = await api.post("/uploads", fd);
  return data.url;
}
